import ReactSelect, { MultiValue, SingleValue } from 'react-select';
import './CustomReactSelect.css';

export interface Option {
  value: string;
  label: string;
}
interface CustomReactSelectProps {
  inputId: string;
  options: Option[];
  onChange: (selectedOptions: Option[] | null) => void;
  value: SingleValue<Option> | MultiValue<Option> | null;
  isMulti?: boolean;
  placeholder?: string;
  isSearchable?: boolean;
}

function CustomReactSelect({
  inputId, options, onChange, value, isMulti = false, placeholder = 'Select...', isSearchable = true,
}: CustomReactSelectProps) {
  const handleChange = (newValue: MultiValue<Option> | SingleValue<Option>) => {
    if (newValue) {
      onChange(Array.isArray(newValue) ? newValue : [newValue]);
      return;
    }

    onChange(null);
  };

  return (
    <ReactSelect
      inputId={inputId}
      data-testid={inputId}
      aria-label={inputId}
      unstyled
      classNames={{
        control: () => 'custom-select-control',
        option: (state) => (state.isFocused ? 'custom-select-option custom-select-option--focused' : 'custom-select-option'),
        menu: () => 'custom-select-menu',
        menuList: () => 'custom-select-menu-list',
        multiValue: () => 'custom-select-multi-value',
        multiValueLabel: () => 'custom-select-multi-value-label',
        multiValueRemove: () => 'custom-select-multi-value-remove',
      }}
      options={options}
      onChange={handleChange}
      value={value}
      isMulti={isMulti}
      placeholder={placeholder}
      isSearchable={isSearchable}
    />
  );
}

export default CustomReactSelect;
